<template>
    <div>
        <h1 style="text-align:center">
            Scheman
        </h1>
        <v-simple-table>
            <thead>
                <tr>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Rubrik
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Lokalisering
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Name
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Link
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Tema
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Skapat Datum
                    </th>
                    <th style="background-color:#D3D3D3;font-size:20px">
                        Handlingar
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="schedule in schedules" :key="schedule.id">
                    <td>{{ schedule.title }}</td>
                    <td>{{ schedule.location }}</td>
                    <td>{{ schedule.first_name }} {{ schedule.last_name }}</td>
                    <td>https://tid.nu/schedule/{{ schedule.schedule_link }}</td>
                    <td v-if="schedule.theme < 11">
                        {{ themes[schedule.theme] }}
                    </td>
                    <td v-if="schedule.theme == 11">
                        {{ schedule.custom_theme }}
                    </td>
                    <td>{{ toDDMMYY(schedule.created_at) }}</td>
                    <td>
                        <v-icon
                            @click="
                                $router.replace(`/showschedule/${schedule.id}`)
                            "
                            style="margin-right:30px"
                            >fas fa-arrow-right</v-icon
                        >
                        <v-icon @click="confirm(schedule.schedule_link)">
                            fa-minus-circle
                        </v-icon>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Är du säker på att du tar bort schemat?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Nej
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="del(did)"
          >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import store from "../../../../store";
export default {
    data: () => ({
        schedules: null,
        store: store,
        dialog: false,
        did: '',
        themes: [
            "Möte",
            "Övrigt",
            "Jobbmöte",
            "Svensexa",
            "Möhippa",
            "Middag",
            "Resa",
            "Fest",
            "Födelsedag",
            "Kalas",
            "Studentskiva",
            "Date"
        ]
    }),
    created: async function() {
        //if (this.store.state.user.role == "user")
        //    this.$router.replace("/dashboard");
        //if (!this.store.state.isLoggedIn) this.$router.replace("/login");
        let resp = await axios.get(`${this.store.state.baseURL}schedules`);
        this.schedules = resp.data;
    },
    methods: {
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        del: async function(id) {
            try {
                await this.store.dispatch("deleteSchedule", id);
            } catch (err) {
                console.log(err);
            }
            window.location.reload();
        },
        confirm: function(id) {
            this.did = id
            this.dialog = true
        }
    }
};
</script>

<style scoped></style>
